<video *ngIf="!!displayedSrc" 
    [controls]="controls"
    class="cwt-media-node cwt-media-node-{{state}}"
    [poster]="poster"
    [src]="srcType === 'url' ? displayedSrc : (displayedSrc | cwtSafe: 'url')"
    (loadedmetadata)="onMediaLoaded()"
    (error)="onMediaError()">

<ng-container *cwtMediaAddonOutlet="addons; state: state"></ng-container>